import React, { forwardRef } from 'react';
import PropTypes        from 'prop-types';
import YouTube          from 'react-youtube';
// import classNames       from 'classnames';

import BG               from '../../../../../assets/images/revolutionary.png';

import styles           from './RevolutionaryBlock.styl';

function RevolutionaryBlock(props, ref) {
    // const {  } = props;

    // const {} = useMessage();
    const opts = {
        height: '495',
        width: '100%',
        playerVars: {
            // https://developers.google.com/youtube/player_parameters
            autoplay: 1,
        },
    };

    return  (
        <section
            ref = {ref}
            className={styles.RevolutionaryBlock}
            style = {{
                backgroundImage    : `url(${BG})`,
                backgroundPosition : 'center',
                backgroundSize     : 'cover'
            }}
        >
            <div className={styles.blockWrapper}>
                <div className={styles.leftBlock}>
                    <YouTube
                        videoId   = "f9TyD_x3Qm4"
                        opts      = {opts}
                        className = {styles.videoPlayer}
                    />;
                </div>
                <div className={styles.rightBlock}>
                    <div className={styles.blockName}>
                        <span className={styles.dot} />
                        Revolutionary
                    </div>
                    <h2 className={styles.blockTitle}>
                        Revolutionizing customer acquisition with automation
                    </h2>
                </div>
            </div>
        </section>
    );
}

RevolutionaryBlock.propTypes = {
    className : PropTypes.string,
    message   : PropTypes.string
};

RevolutionaryBlock.defaultProps = {
    className : '',
    message   : ''
};

export default forwardRef(RevolutionaryBlock);
